import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { useController } from "react-hook-form";
import { FormContext } from "components/shared/Form";
import { StyledTextField } from "components/ui/atoms/SelectAutocomplete";

const RHFDatePicker = ({ name, label, fullWidth, hideErrorText, ...props }) => {
  const {
    form: { control },
  } = useContext(FormContext);

  const {
    field,
    fieldState: { error: fieldStateError, invalid },
  } = useController({
    control: control,
    name: name,
  });

  const [value, setValue] = useState(field.value ? dayjs(field.value) : null);
  const [error, setError] = useState("");

  const handleChange = (date) => {
    if (date && date.isValid()) {
      field.onChange(date.format("YYYY-MM-DD"));
      setError("");
    } else {
      field.onChange(null);
      if (date) {
        setError("Invalid date format");
      } else {
        setError("");
      }
    }
    setValue(date);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <MuiDatePicker
        label={label}
        enableAccessibleFieldDOMStructure={false}
        views={["day"]}
        openTo={"day"}
        format={"DD/MM/YYYY"}
        mask={"__/__/____"}
        disableMaskedInput={false}
        slots={{
          textField: StyledTextField,
        }}
        slotProps={{
          textField: {
            fullWidth: fullWidth,
            variant: "standard",
            helperText: hideErrorText ? "" : error || fieldStateError?.message,
            error: invalid || Boolean(error),
          },
        }}
        value={value}
        onChange={handleChange}
        onBlur={field.onBlur}
        inputRef={field.ref}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default RHFDatePicker;
